<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        props: {
            chartdata: Array,
            options: Array,
            dataname: String,
            stepSize: Number
        },
        mounted () {
            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: '#2E7D32',
                        data: this.options,
                    }
                ]
            }, {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            stepSize: this.stepSize ? this.stepSize:'2',
                        },
                        gridLines: {
                            display: true,
                            zeroLineColor: "black",
                            zeroLineWidth: 2

                        },
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false,
                        },
                    }]
                },
                legend: {
                    labels: {
                        boxWidth: 0,
                        fontSize: 24
                    }
                },

            })
        },
    }
</script>

<style scoped>

</style>
